import { GridCellParams } from '@mui/x-data-grid-pro';
import Chip from '@mui/material/Chip';
import { GridCustomColDef } from '../../types';
import { chipStyles, getFormattedDate } from '../../../utils/helpers';

export const DefaultRunGridColumnDefs: GridCustomColDef[] = [
  {
    headerName: 'Run',
    field: 'name',
    flex: 1,
    sortable: false
  },
  {
    headerName: 'ID',
    field: 'id',
    flex: 1,
    sortable: false
  },
  {
    type: 'singleSelect',
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'status',
    align: 'center',
    renderCell: (params: GridCellParams) => {
      const status = params.value as string;
      if (!status) return '';
      return (
        <Chip
          label={status}
          size="small"
          sx={chipStyles(status)}
          title={status}
        />
      );
    },
    headerName: 'Status',
    sortable: false,
    filterable: false,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    headerName: 'RPM Run',
    field: 'rpm_run_id',
    flex: 1,
    sortable: false
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'statusAt',
    headerName: 'Status At',
    valueFormatter: (value) => {
      return getFormattedDate(value);
    },
    valueGetter: (value) => {
      return value ? new Date(value) : '';
    },
    sortable: false,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'statusBy.email',
    headerName: 'Status By',
    sortable: false,
    flex: 1,
    description: 'Drag to move column',
    valueGetter: (_value, row) => row?.statusBy?.email
  }
];
